import { isUuid } from './uuid';

/** Use the loaded job row id for retry/cancel — never subscription/search/item ids. */
export function resolveJobRetryId(
  job: { id: string } | null | undefined,
  fallbackJobId: string,
): string {
  if (job?.id && isUuid(job.id)) return job.id;
  return fallbackJobId;
}

export function jobRetryApiPath(jobId: string): string {
  return `/api/jobs/${encodeURIComponent(jobId)}/retry`;
}
